import { gql } from "@apollo/client";

export default gql`
  query getPusherMeetingTranscriptionStatusQuery($meetingId: Int!) {
    meeting(meetingId: $meetingId) {
      id
      transcriptionStatus
    }
  }
`;
